const useGetInfoServices = () => {
    const getInfoServices = (services) => {
        const isUniqueService = services.length == 1
        const convertServices = services.map(service => {
            const obj = {
                id: service.id,
                sku: service.sku,
                name: service.name,
                short_name: service.short_name,
                category: service.category,
                quantity: service.quantity,
                price: {
                    unit_price: parseInt((service.amount * 100).toFixed()),
                    discount: service.discount_option == "percent" ? service.discount : parseInt((service.discount * 100).toFixed()),
                    discount_type: service.discount_option,
                    discount_amount: parseInt((service.discount_amount * 100).toFixed()),
                    special_price: {
                        unit_price: service.amount * 100,
                        discount: isUniqueService ? 0: (service.pack_discount_option == 'percent' ? service.pack_discount : parseInt((service.pack_discount * 100).toFixed())),
                        discount_type: service.pack_discount_option,
                        discount_amount: isUniqueService ? 0 : parseInt((service.pack_discount_amount * 100).toFixed()),
                    }
                },
                recurrent: service.recurrent,
                periods: [],
                periodicity: service.periodicity,
                notes: service.notes,
            }
            const convertDates = service.dates.map(date => {
                return date.id
            });
            obj.periods = convertDates;
            return obj;
        });
        return convertServices
    }
    return { getInfoServices }
}

export default useGetInfoServices;